import React from 'react';
import PropTypes from 'prop-types';

const ArticleThumbnail = props => {

    const {data, openArticle} = props;

    const articleImg = {
        backgroundImage: `url('${data.article_img}')`,
    };

    const sourceIcon = {
        backgroundImage: `url('${data.source_icon}')`,
    };

    return (
        <div className="article__thumbnail" data-newsitem={`news${data.id}`}>
            <div className={`shadow white ${props.hover ? 'article__thumbnailInner' : 'article__thumbnailInnerNoHov'}`}
                 onClick={e => openArticle(e, `news${data.id}`)}>
                <div className="article__thumbnailImage h10 oh relative">
                    <div className="article__thumbnailImageWrap bg-center"
                         style={articleImg}/>
                    <svg className="aspect" viewBox="0 0 5 3">
                        <rect x="0" y="0" width="5" height="3"/>
                    </svg>
                </div>
                <div className="article__metaWrap pr2 pt2 pl2 flex">
                    <div className="article__srcIcon bg-center"
                         style={sourceIcon}/>
                    <div className="article__meta">
                        <h5>{data.source}</h5>
                        {/*<p className="date">{data.date}</p>*/}
                    </div>
                </div>
                <div className="article__thumbnailText pl2 pb2 pr2">
                    <h5>{data.title}</h5>
                    {/*<p>{data.excerpt}</p>*/}
                </div>
            </div>
        </div>
    )
};

ArticleThumbnail.propTypes = {
    data: PropTypes.object.isRequired,
    openArticle: PropTypes.func.isRequired,
    hover: PropTypes.bool,
};

ArticleThumbnail.defaultProps = {
    hover: true,
};

export default ArticleThumbnail;
